module.exports = __webpack_public_path__ + "static/media/icon-paperclip.cd8c4662.svg";